<template>
    <div class="preUser expand">
        <div class="preUser-left">
            <div class="content-login"> 
                <b-link to="/" style="width: fit-content;">
                    <img class="logo" src="@/assets/img/logo-login.png">
                </b-link>     
                <b-form class="Login">
                    <template v-if="!nextStep">
                        <div class="body">
                            <header>
                                <h6 class="sub-title">
                                    <span v-if="this.is_student">Nueva Contraseña</span>
                                    <span v-else>New Password</span>
                                </h6>
                            </header>
                            <b-form-group :label="this.is_student ? 'Nueva Contraseña' : 'New Password'">
                                <b-icon class="eye" :icon="eyesPassword1 ? 'eye-slash':'eye'" aria-hidden="true" @click="eyesPassword1=!eyesPassword1"></b-icon>
                                <b-form-input 
                                    required
                                    v-model="nwPassword"
                                    @blur="$v.nwPassword.$touch()"
                          
                                    :type="eyesPassword1 ? 'password':'text'"
                                ></b-form-input>
                                <div class="error-label">{{ validationMsg($v.nwPassword) }}</div>
                            </b-form-group>
                             <b-form-group :label="this.is_student ? 'Confirmar contraseña' : 'Confirm password'">
                                <b-icon class="eye" :icon="eyesPassword2 ? 'eye-slash':'eye'" aria-hidden="true" @click="eyesPassword2=!eyesPassword2"></b-icon>
                                <b-form-input
                                    required
                                    v-model="confirmNwPassword"
                                    @blur="$v.confirmNwPassword.$touch()"
                                  
                                    v-on:keydown.enter.prevent="resetPassword"
                                    :type="eyesPassword2 ? 'password':'text'"
                                ></b-form-input>
                                <div class="error-label">{{ validationMsg($v.confirmNwPassword) }}</div>
                            </b-form-group>
                            <b-button v-if="this.is_student" variant="primary" class="mb-2 mt-1 w-auto" :disabled="$v.nwPassword.$invalid || $v.confirmNwPassword.$invalid"  @click="resetPassword" :class="{ loading: showSpinnerSave }" >
                                Restablecer contraseña
                            </b-button>
                             <b-button v-else variant="primary" class="mb-2 mt-1 w-auto" :disabled="$v.nwPassword.$invalid || $v.confirmNwPassword.$invalid"  @click="resetPassword" :class="{ loading: showSpinnerSave }" >
                                Reset password
                            </b-button>
                        </div>
                        <p class="mb-0">
                            <span v-if="this.is_student">
                                <a href="/student/login" class="link mt-3">
                                    <span>Regresar al login</span>
                                </a>
                            </span>
                            <span v-else>
                                <a href="/teacher/login" class="link mt-3">
                                    <span >Back to login</span>
                                </a>
                            </span>
                        </p>
                    </template>
                    <template v-else>
                        <div v-if="this.is_student">
                            <header >
                                <h6 class="sub-title"><span>Contraseña Actualizada</span></h6>
                            </header>
                            <p>Tu nueva contraseña ha sido actualizada sigue disfrutando de la experiencia en English Advanced.</p> 
                            <b-button  variant="primary" class="mt-4 w-auto" @click="$router.push({path : '/'});nextStep=false;"  >
                                Entendido
                            </b-button>

                        </div>
                        <div v-else>
                            <header >
                                <h6 class="sub-title"><span>Password Updated</span></h6>
                            </header>
                            <p>Your new password has been updated. Keep enjoying the English Advanced experienced.</p> 
                            <b-button  variant="primary" class="mt-4 w-auto" @click="$router.push({path : '/'});nextStep=false;"  >
                                OK
                            </b-button>

                        </div>
                        
                    </template>
                </b-form>
            </div>
        </div>
        <div class="preUser-right">
            <img src="@/assets/img/login-background2.jpg" class="no_mb"/>
            <p>{{$t('footer-web.text')}} <br class="no_desktop">{{$t('footer-web.text-2')}}</p>
        </div>
        <b-toast
            id="toast-error-reset-password"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center"
            >
            <img
                src="@/assets/img/ico-equis.png"
                style="margin-right: 10px; margin-top: -2px"
            />
            {{ message }}
		</b-toast>

          <b-toast
            id="toast-check-reset-password"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center"
            >
            	<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
            {{ message }}
		</b-toast>
    </div>
    
</template>
<script>
import { PERFILES} from '@/assets/js/appConstants'; 
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import {
  required,
  sameAs,
  maxLength
} from "vuelidate/lib/validators";
import { validationMessage } from 'vuelidate-messages';
const formMessagesLogin = { 
    required: function (){
        return this.$t('validations.formMessagesLogin.required')
    },
    sameAsPassword:function (){
        return this.$t('validations.formRegisterMessages.sameAsPassword')
    },
    strongPassword:function (){
        return this.$t('validations.formRegisterMessages.strongPassword')
    },
    noWhitespaces:function (){
        return this.$t('validations.formRegisterMessages.noWhitespacesPassword')
    },
    maxLength:function ({ $params }){
        return `${this.$t('validations.formRegisterMessages.maxLength.1')} ${$params.maxLength.max } ${this.$t('validations.formRegisterMessages.maxLength.2')}`
    }

};


export default {
    data:function(){
        return{
            showSpinnerSave: false,
            key: null,
            nwPassword: null,
            confirmNwPassword: null,
            message: '',
            nextStep :false,
            eyesPassword1:true,
            eyesPassword2:true,
            is_student: true,
        }
    },
    created(){
        this.key = this.$route.params.key;
        
        this.validateRecoveryKey();
    },
    computed: {  
    },
    validations: {
        nwPassword: {
        required,
        maxLength: maxLength(20),
        strongPassword(password) {
            return (
                /[a-z]/.test(password) && // condición minúscula (a-z)
                        /[A-Z]/.test(password) && // condición mayúscula  (A-Z)
                        /[0-9]/.test(password) && // condición número (0-9)
                        /\W|_/.test(password) && // condición símbolo
                        password.length >= 6
            );
            },
        noWhitespaces(password) {
            return !/["/ +/"]/.test(password); // condición no espacios en blanco
        }
        },
        confirmNwPassword: {
            required,
            sameAsPassword: sameAs("nwPassword")
        }
    },
    methods: {
        validateRecoveryKey(){
            let data = {
                key : this.key
            }
        

             baseInstanceAxios
				.get(`${this.apiURL}/resources/Persons/GetValidateRecoveryKey`, {
                    params : data
                })
				.then(response => {
                    //console.log("response: ",response)	
               
                   this.is_student = response.data.entity.profileId == PERFILES.ALUMNO;
                   this.$i18n.locale = this.is_student ? "es":"en";
               
                    if(response.data.value == 0 ){
                        this.message = this.$t('reusables.email-not-valid');
                        this.$bvToast.show("toast-error-reset-password");
                    }

                     if(response.data.value == 1){
                        this.message = this.$t('reusables.user-not-active');
                        this.$bvToast.show("toast-error-reset-password");

                    }

                    if(response.data.value == 0 || response.data.value == 1){
                        this.$router.push({ name: 'login' });
                    }

				})
                .catch(error => {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-error-reset-password");
                });
        },
        resetPassword(){
            this.showSpinnerSave  = true;
            let json = {
                key: this.key,
                Password:this.nwPassword
            }
             baseInstanceAxios
				.post(`${this.apiURL}/resources/Persons/SavePasswordRecovery`, json)
				.then(response => {
               
                  
                    if(response.data.value == 0){
                        this.message = this.$t('reusables.email-not-valid');
                        this.$bvToast.show("toast-error-reset-password");
                    }

                     if(response.data.value == 1){
                        this.message = this.$t('reusables.user-not-active');
                        this.$bvToast.show("toast-error-reset-password");

                    }

                     if(response.data.value == 2){
                        this.message = this.$t('reusables.password-was-changed');
                        this.$bvToast.show("toast-check-reset-password");
                        this.nextStep = true;
      
                    }
                     this.showSpinnerSave  = false;
				})
                .catch(error => {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-error-reset-password");
                    this.showSpinnerSave = false;
                });
        },
        validationMsg: validationMessage(formMessagesLogin),
     
  
    },
};
</script>